module.exports = __webpack_public_path__ + "onboarding-variable.e57298c6d1c3ba90134886b6538c875a.hashedasset.svg";